<div class="container"
    *ngIf="nextConfig.layout === 'horizontal' && nextConfig.subLayout === 'horizontal-2'; else mainHeader">
    <ng-container *ngTemplateOutlet="mainHeader"></ng-container>
  </div>

<ng-template #mainHeader>
    
    <div class="m-header">
        <a id="mobile-collapse"
            href="javascript:"
            class="mobile-menu"
            (click)="navCollapse()">
            <span></span>
        </a>

        <a routerLink="/dashboard/analytics" class="b-brand">
            <img *ngIf="nextConfig.navBrandColor !== 'brand-default' || nextConfig.headerBackColor !== 'header-default'"
                id="main-logo"
                src="assets/images/FW-Retail-Insights-primary-color.svg"
                alt=""
                class="logo"
                >
            <img *ngIf="nextConfig.navBrandColor === 'brand-default' && nextConfig.headerBackColor === 'header-default'"
                src="assets/images/logo-dark.png"
                alt=""
                class="logo">

            <img src="assets/images/logo-icon.png"
                alt=""
                class="logo-thumb">
        </a>
        <span class="versionNumber">{{version}}</span>
        <a class="mob-toggler"
            [ngClass]="{'on' : menuClass}"
            href="javascript:"
            (click)="toggleMobOption()">
            <i class="feather icon-more-vertical"></i>
        </a>
    </div>

    <div class="collapse navbar-collapse" [style.display]="collapseStyle">
      <div class="nav-bar-user-name">
        <i *ngIf="globalService.isSuperUser" class="superIcon fab fa-superpowers"></i><strong class="h5">{{globalService.username}}</strong>
      </div>
    </div>

</ng-template>
